// เก็บชีวิตที่เล่นค้างไว้ในเบราว์เซอร์ เปิดหน้าใหม่จะได้เล่นต่อได้
// localStorage อาจใช้ไม่ได้ (โหมดส่วนตัว ปิดคุกกี้) เกมต้องเล่นได้แม้บันทึกไม่ได้

import type { LifeState } from "../engine/types";
import type { SpawnResult } from "../shared/api";
import { emptyDex, parseDex, type Dex } from "../shared/dex";
import { emptyAchievements, parseAchievements, type AchievementState } from "../shared/achievements";

const KEY = "wildlifepack:v1:life";

export interface SavedLife {
  spawn: SpawnResult;
  life: LifeState;
}

export function loadSaved(): SavedLife | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw) as SavedLife;
    return saved.life?.alive ? saved : null;
  } catch {
    return null;
  }
}

export function save(saved: SavedLife): void {
  try {
    if (saved.life.alive) localStorage.setItem(KEY, JSON.stringify(saved));
    else localStorage.removeItem(KEY);
  } catch {
    // บันทึกไม่ได้ก็เล่นต่อได้ตามปกติ
  }
}

export function clearSaved(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ไม่มีอะไรต้องทำ
  }
}

// ---------- สมุดสัตว์ (src/shared/dex.ts) ----------

const DEX_KEY = "wildlifepack:v1:dex";

export function loadDex(): Dex {
  try {
    return parseDex(localStorage.getItem(DEX_KEY));
  } catch {
    return emptyDex();
  }
}

export function saveDex(dex: Dex): void {
  try {
    localStorage.setItem(DEX_KEY, JSON.stringify(dex));
  } catch {
    // บันทึกไม่ได้ สมุดสัตว์ก็แค่ไม่ถูกเก็บไว้
  }
}

// ---------- ความสำเร็จ (src/shared/achievements.ts) ----------

const ACHIEVEMENTS_KEY = "wildlifepack:v1:achievements";

export function loadAchievements(): AchievementState {
  try {
    return parseAchievements(localStorage.getItem(ACHIEVEMENTS_KEY));
  } catch {
    return emptyAchievements();
  }
}

export function saveAchievements(state: AchievementState): void {
  try {
    localStorage.setItem(ACHIEVEMENTS_KEY, JSON.stringify(state));
  } catch {
    // บันทึกไม่ได้ ความสำเร็จก็แค่ไม่ถูกเก็บไว้
  }
}
